import { Box, styled, TableContainer } from "@mui/material";
import { grey } from "@mui/material/colors";

export const LayerHeaderBox = styled(Box)({
  height: 42,
  padding: "0 8px",
  backgroundColor: grey[100],
  border: `1px solid ${grey[300]}`,
  borderRadius: "4px 4px 0 0",
  borderBottomWidth: 0,
  display: "flex",
  justifyContent: "space-between",
});

export const LayerTableContainer = styled(TableContainer)({
  border: `1px solid ${grey[300]}`,
  borderRadius: "0 0 4px 4px",
  borderTop: "unset",
});

export const IconBox = styled(Box)({
  marginRight: 8,
  height: 22,
});
